import { render, staticRenderFns } from "./self-diagnosis.vue?vue&type=template&id=bf41e36a&scoped=true"
import script from "./self-diagnosis.vue?vue&type=script&lang=ts"
export * from "./self-diagnosis.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf41e36a",
  null
  
)

export default component.exports